import { render, staticRenderFns } from "./sellDetailSim.vue?vue&type=template&id=aeb980aa&scoped=true&"
import script from "./sellDetailSim.vue?vue&type=script&lang=js&"
export * from "./sellDetailSim.vue?vue&type=script&lang=js&"
import style0 from "./sellDetailSim.vue?vue&type=style&index=0&id=aeb980aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb980aa",
  null
  
)

export default component.exports